import vaisaLogo from './../../assets/image/vaisa/vaisa_logo.png'
import vaisaBanner from './../../assets/image/vaisa/vaisa_bg.jpg'
import vaisaH5Banner from './../../assets/image/vaisa/vaisa_h5_bg.png'
import vaisaLunchApp from './../../assets/image/vaisa/button_launch_app.png'

import React, {useEffect, useState} from 'react';
import './index.css'
const Vaisa = () => {

  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    setIsMobile(/android|iphone|ipad|ipod|blackberry|windows phone/i.test(userAgent));
  }, []);

  return (
    <div className="vaisa-container">
      {
        isMobile?(
          <div className="vaisa-h5-nav flex">Vishwa</div>
        ):(
          <div className="vaisa-nav flex">
            <div className="vaisa-logo">
              <img src={vaisaLogo}/>
            </div>
            <div className="vaisa-nav-title">VaiSA</div>
            <div className="vaisa-nav-btn">
              Lunch App
            </div>
          </div>
        )
      }

      <div className="vaisa-content" style={isMobile?{marginTop:'44px'}:null}>
        <img src={isMobile ? vaisaH5Banner : vaisaBanner} className="banner"/>
        <img src={isMobile ? vaisaLunchApp : null} className="lunch-app-btn"/>
      </div>

    </div>
  );
}

export default Vaisa;